<!-- 关键特征 -->
<template>
  <div class="home">
    <!-- Header -->
    <Header @openForm="openForm" :isPageScroll="isPageScroll" :headColor="headColor" :router="'Product'"></Header>
    <div class="content">
      <div class="visualDevelopment" id="visualDevelopment">
        <div class="visualDevelopment-div">
          <div class="visualDevelopment-left">
            <div class="visualDevelopment-title">可视化开发</div>
            <div class="visualDevelopment-desc">轻骑兵低代码PaaS平台提供基于拖拽配置式的可视化页面、流程设计器，提供了一系列可扩展组件库、自定义组件库、页面模板库、公共样式库等资源库，支持用户通过“拖拉拽+简单配置”的方式，完成多种复杂场景下的原型绘制、功能开发、数据库设计、流程设计、移动开发等工作。
            </div>
          </div>
          <div class="visualDevelopment-right">
            <div>
              <img class="visualDevelopment-img" src="../assets/img/homePage/function1.gif"/>
            </div>
            <img class="visualDevelopment-img2" src="../assets/img/keyFeatures/visualDevelopment-img2.png" style="margin-top: 1px"/>
          </div>
        </div>
      </div>
      <div class="aiAbility" id="aiAbility">
        <div class="aiAbility-div">
          <div class="aiAbility-left">
            <img src="../assets/img/keyFeatures/aiAbility-img.png"/>
          </div>
          <div class="aiAbility-right">
            <div class="aiAbility-title">AI能力</div>
            <div class="aiAbility-desc">轻骑兵低代码PaaS平台基于ChatGLM大模型，实现可视化开发过程中的模块、表单、字段等智能推荐的功能，易用性和开发效率进一步提升，具有低成本部署，性能高的特点。</div>
          </div>
        </div>
        <img src="../assets/img/keyFeatures/aiAbility-img2.png" class="aiAbility-img2"/>
      </div>
      <div class="comprehensive" id="comprehensive">
        <div class="comprehensive-div">
          <div class="comprehensive-left">
            <div class="comprehensive-title">全面信创</div>
            <div class="comprehensive-desc">轻骑兵低代码PaaS平台支持信创，全面兼容了国产化软硬件生态体系，包括国产化服务器、操作系统、数据库、中间件等，信息安全可控。</div>
          </div>
          <div class="comprehensive-right">
            <img src="../assets/img/keyFeatures/comprehensive-img.png" class="comprehensive-img"/>
            <img src="../assets/img/keyFeatures/comprehensive-img2.png" class="comprehensive-img2"/>
          </div>
        </div>
      </div>
      <div class="expand" id="expand">
        <div class="expand-div">
          <div class="expand-left">
            <div>
              <video src="../assets/video/expend1.mp4" controls="true"/>
            </div>
            <img class="visualDevelopment-img2" src="../assets/img/keyFeatures/visualDevelopment-img2.png" style="margin-top: 1px"/>
          </div>
          <div class="expand-right">
            <div class="expand-title">灵活拓展</div>
            <div class="expand-desc">轻骑兵低代码PaaS平台提供了公式编辑、在线脚本编辑、外部资源注册和代码全解析4种二次开发扩展方式，实现复杂业务场景的开发。</div>
          </div>
        </div>
      </div>
      <div class="security" id="security">
        <div class="security-div">
          <div class="security-left">
            <div class="security-title">安全可靠</div>
            <div class="security-desc">轻骑兵低代码PaaS平台具有高安全性的平台架构。轻骑兵参照《国家信息安全等级保护管理办法》进行设计建设，符合安全测试8个大项126个小项，其中的8个大项包括：标识和鉴别、数据保密性、数据完整性、外部接口、会话管理、安全审计、访问控制、软件容错，同时轻骑兵融合了大型网站系统安全的设计经验以及传统管理系统的安全手段，在防攻击、防注入、安全加密等方面进行了安全加固，保证了系统的数据存储安全、传输安全。</div>
          </div>
          <div class="security-right">
            <img src="../assets/img/keyFeatures/security-img.png"/>
          </div>
        </div>
      </div>
      <div class="singleService" id="singleService">
        <div class="singleService-div">
          <div class="singleService-left">
            <img src="../assets/img/keyFeatures/singleService-img.png"/>
          </div>
          <div class="singleService-right">
            <div class="singleService-title">单体/微服务架构</div>
            <div class="singleService-desc">轻骑兵低代码PaaS平台提供单体与微服务架构两种开发模式，支持从单体架构直接切换到微服务架构。平台提供全套的微服务相关服务支撑，能够快速搭建微服务应用。</div>
          </div>
        </div>
      </div>
    </div>
    <!-- footer -->
    <FhBottom/>
    <!-- 右侧联系方式 -->
    <SideBar @openForm="openForm"></SideBar>
    <!-- 表单 -->
    <HussarForm v-show="showForm" @closeForm="closeForm"></HussarForm>
    <!-- 返回顶部 -->
    <img src="../assets/img/homePage/top.png" class="back-top" @click="backTop" v-if="isPageScroll">
  </div>
</template>

<script>
import HussarForm from './include/HussarForm.vue';
import SideBar from './include/SideBar.vue';
import Header from './include/Header.vue';

export default {
  name: "KeyFeatures",
  data() {
    return {
      headColor:"dark",
      isPageScroll: false,
      showForm: false,
      isSubmit: false
    };
  },
  components: {
    Header,
    HussarForm,
    SideBar
  },
  watch:{
    $route(now){
      let nameId = now.query.name.replaceAll('#','');
      let targetbox= document.getElementById(nameId);
      let target= targetbox.offsetTop;
      $('html ,body').animate({scrollTop: target}, 700);
    }
  },
  methods: {
    // 跳转页面
    jumpTo(page) {
      const self = this;
      self.$router.push({ path: page });
    },
    changeBg(n) {
      const self = this;
      self.caseBgIndex = n;
    },
    openForm() {
      const self = this;
      self.showForm = true;
    },
    closeForm() {
      const self = this;
      self.showForm = false;
    },
    toLink() {
      window.open("http://www.jxdinfo.com");
    },
    // 返回顶部
    backTop() {
      $('html ,body').animate({scrollTop: 0}, 700);
    },
    // 页面滚动
    handleNavScroll() {
      const self = this;
      self.isPageScroll = false;
      const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      if (scrollTop > 80) {
        self.isPageScroll = true;
      }
    },
  },
  mounted() {
    // 视频播放
    var sUserAgent = navigator.userAgent;
    var phoneFlag = sUserAgent.indexOf('Android') > -1 || sUserAgent.indexOf('iPhone') > -1
      || sUserAgent.indexOf('iPad') > -1 || sUserAgent.indexOf('iPod') > -1 || sUserAgent.indexOf('Symbian') > -1;
    if(phoneFlag){
      document.getElementsByTagName('body')[0].classList.add('mobile')
      var oWidth = document.body.clientWidth || document.documentElement.clientWidth;
      document.getElementsByTagName("html")[0].style.fontSize = oWidth/750*100 + "px";
    }
    window.addEventListener('scroll', this.handleNavScroll);
    var ua = navigator.userAgent,
      isWindowsPhone = /(?:Windows Phone)/.test(ua),
      isSymbian = /(?:SymbianOS)/.test(ua) || isWindowsPhone,
      isAndroid = /(?:Android)/.test(ua),
      isFireFox = /(?:Firefox)/.test(ua),
      isChrome = /(?:Chrome|CriOS)/.test(ua),
      isTablet = /(?:iPad|PlayBook)/.test(ua) || (isAndroid &&       !/(?:Mobile)/.test(ua)) || (isFireFox && /(?:Tablet)/.test(ua)),
      isPhone = /(?:iPhone)/.test(ua) && !isTablet,
      isPc = !isPhone && !isAndroid && !isSymbian;
    var os = {
      isTablet: isTablet,
      isPhone: isPhone,
      isAndroid: isAndroid,
      isPc: isPc
    };
    if (os.isAndroid || os.isPhone) {
      this.$router.replace({ path: '/keyfeaturesphone' });
    }
    this.$nextTick(function(){
      if(this.$route.query.name){
        this.$el.querySelector(this.$route.query.name).scrollIntoView()
      }
    })
  }
};
</script>

<style scoped>
.home {color: #2E2E2E;}
.home >>> .header-con > div a{height: 100%;display: flex;align-items:center;color: #2e2e2e;}
.home >>> .navigator > div a:hover,.navigator .isActive {color: #186CF5;}
.more-btn {position: relative;left: 50%;transform: translateX(-50%);width: 120px;height: 42px;background: #186CF5;border-radius: 5px;font-size: 16px;text-align: center;color: #FFF;line-height: 42px;cursor: pointer;}
.more-btn:hover {background: rgba(21, 132, 243, 0.9);}
.value-btn {position: relative;left: 50%;transform: translateX(-50%);width: 110px;height: 38px;background: #FFF;border-radius: 5px;font-size: 16px;text-align: center;color: #186CF5;line-height: 38px;cursor: pointer;}
.value-btn:hover {background: rgba(255, 255, 255, 0.9);}

.content{scroll-snap-type:y mandatory;}
.content > div{scroll-snap-align:start}

/*可视化开发*/
.visualDevelopment{height: 100vh;width:100vw;background: url("../assets/img/keyFeatures/visualDevelopment-bg.png") no-repeat;background-size: 100% 100%;padding-top: 260px;text-align: center;}
.visualDevelopment-div{width: 1200px;display: flex;justify-content: center;margin:auto}
.visualDevelopment-left{margin-right: 50px}
.visualDevelopment-right{position: relative;left: 20px;top: -30px}
.visualDevelopment-right div{background: #B7D1F7;border-radius: 5px;width: 850px;}
.visualDevelopment-img{width: 830px;margin: 10px 0px}
.visualDevelopment-img2{width: 850px;}
.visualDevelopment-title{font-size: 38px;color: #2E2E2E;line-height: 52px;font-weight: bold;margin-bottom: 60px;text-align: left}
.visualDevelopment-desc{font-size: 16px;color: #333333;line-height: 34px;text-align: justify}

/*ai能力*/
.aiAbility{height: 100vh;width:100vw;background: url("../assets/img/keyFeatures/aiAbility-bg.png") no-repeat;background-size: 100% 100%;padding-top: 250px;text-align: center;}
.aiAbility-div{width: 1200px;display: flex;justify-content: center;margin:auto}
.aiAbility-right{margin-left: 40px}
.aiAbility-left{position: relative;right: 20px}
.aiAbility-title{font-size: 38px;color: #2E2E2E;line-height: 52px;font-weight: bold;margin-bottom: 60px;text-align: right}
.aiAbility-desc{font-size: 16px;color: #333333;line-height: 34px;text-align: justify}
.aiAbility-img2{position: relative;left: 500px;top: -70px}

/*全面信创*/
.comprehensive{height: 100vh;width:100vw;background: url("../assets/img/keyFeatures/comprehensive-bg.png") no-repeat;background-size: 100% 100%;padding-top: 250px;text-align: center;}
.comprehensive-div{width: 1200px;display: flex;justify-content: center;margin:auto}
.comprehensive-left{margin-right: 60px}
.comprehensive-right{position: relative;left: 20px;top: -120px}
.comprehensive-title{font-size: 38px;color: #2E2E2E;line-height: 52px;font-weight: bold;margin-bottom: 60px;text-align: left}
.comprehensive-desc{font-size: 16px;color: #333333;line-height: 34px;text-align: justify}
.comprehensive-img2{position: relative;top: -600px;left:370px;width: 180px}

/*灵活拓展*/
.expand{height: 100vh;width:100vw;background: url("../assets/img/keyFeatures/expand-bg.png") no-repeat;background-size: 100% 120%;padding-top: 250px;text-align: center;}
.expand-div{width: 1200px;display: flex;justify-content: center;margin:auto}
.expand-right{margin-left: 55px}
.expand-left{position: relative;right: 20px;top: -50px}
.expand-left div{background: #B7D1F7;border-radius: 5px;width: 850px;}
.expand-title{font-size: 38px;color: #2E2E2E;line-height: 52px;font-weight: bold;margin-bottom: 60px;text-align: right}
.expand-desc{font-size: 16px;color: #333333;line-height: 34px;text-align: justify}
.expand video{width: 830px;margin: 10px 0px;}

/*安全可靠*/
.security{height: 100vh;width:100vw;background: url("../assets/img/keyFeatures/security-bg.png") no-repeat;background-size: 100% 100%;padding-top: 250px;text-align: center;}
.security-div{width: 1200px;display: flex;justify-content: center;margin:auto}
.security-left{margin-right: 20px}
.security-right{position: relative;left: 20px;top: -50px}
.security-title{font-size: 38px;color: #2E2E2E;line-height: 52px;font-weight: bold;margin-bottom: 60px;text-align: left}
.security-desc{font-size: 16px;color: #333333;line-height: 34px;text-align: justify}
.security-right img{width: 850px}

/*单服务*/
.singleService{height: 100vh;width:100vw;background: url("../assets/img/keyFeatures/singleService-bg.png") no-repeat;background-size: 100% 100%;padding-top: 250px;text-align: center;}
.singleService-div{width: 1200px;display: flex;justify-content: center;margin:auto}
.singleService-right{margin-left: 40px}
.singleService-left{position: relative;right: 20px;top: -150px}
.singleService-title{font-size: 38px;color: #2E2E2E;line-height: 52px;font-weight: bold;margin-bottom: 60px;text-align: right}
.singleService-desc{font-size: 16px;color: #333333;line-height: 34px;text-align: justify}

/* 返回顶部 */
.back-top {position: fixed;top: calc(40% + 250px);right: 5px;cursor: pointer;}
/*取消页面光标*/
.model-box div,img{caret-color: transparent;}

@media screen and (max-width: 1301px) {
  /*可视化开发*/
  .visualDevelopment{height: 100vh;width:100vw;background: url("../assets/img/keyFeatures/visualDevelopment-bg.png") no-repeat;background-size: 100% 100%;padding-top: 150px;text-align: center;}
  .visualDevelopment-div{width: 1050px;display: flex;justify-content: center;margin:auto}
  .visualDevelopment-left{margin-right: 100px}
  .visualDevelopment-right{position: relative;left: 20px;top: -30px}
  .visualDevelopment-right div{background: #B7D1F7;border-radius: 5px;width: 650px;}
  .visualDevelopment-img{width: 630px;margin: 10px 0px}
  .visualDevelopment-img2{width: 650px;}
  .visualDevelopment-title{font-size: 38px;color: #2E2E2E;line-height: 52px;font-weight: bold;margin-bottom: 60px;text-align: left}
  .visualDevelopment-desc{font-size: 16px;color: #333333;line-height: 34px;text-align: justify}

  /*ai能力*/
  .aiAbility{height: 100vh;width:100vw;background: url("../assets/img/keyFeatures/aiAbility-bg.png") no-repeat;background-size: 100% 100%;padding-top: 150px;text-align: center;}
  .aiAbility-div{width: 1050px;display: flex;justify-content: center;margin:auto}
  .aiAbility-right{margin-left: 100px}
  .aiAbility-left{position: relative;right: 20px}
  .aiAbility-left img{width: 700px}
  .aiAbility-title{font-size: 38px;color: #2E2E2E;line-height: 52px;font-weight: bold;margin-bottom: 60px;text-align: right}
  .aiAbility-desc{font-size: 16px;color: #333333;line-height: 34px;text-align: justify}
  .aiAbility-img2{position: relative;left: 400px;top: -50px;width: 150px}

  /*全面信创*/
  .comprehensive{height: 100vh;width:100vw;background: url("../assets/img/keyFeatures/comprehensive-bg.png") no-repeat;background-size: 100% 100%;padding-top: 200px;text-align: center;}
  .comprehensive-div{width: 1050px;display: flex;justify-content: center;margin:auto}
  .comprehensive-left{margin-right: 60px}
  .comprehensive-right{position: relative;left: 20px;top: -120px}
  .comprehensive-right .comprehensive-img{width: 700px}
  .comprehensive-title{font-size: 38px;color: #2E2E2E;line-height: 52px;font-weight: bold;margin-bottom: 60px;text-align: left}
  .comprehensive-desc{font-size: 16px;color: #333333;line-height: 34px;text-align: justify}
  .comprehensive-img2{position: relative;top: -520px;left:325px;width: 150px}

  /*灵活拓展*/
  .expand{height: 100vh;width:100vw;background: url("../assets/img/keyFeatures/expand-bg.png") no-repeat;background-size: 100% 120%;padding-top: 150px;text-align: center;}
  .expand-div{width: 1050px;display: flex;justify-content: center;margin:auto}
  .expand-right{margin-left: 55px}
  .expand-left{position: relative;right: 20px;top: -50px}
  .expand-left div{background: #B7D1F7;border-radius: 5px;width: 720px;}
  .expand-title{font-size: 38px;color: #2E2E2E;line-height: 52px;font-weight: bold;margin-bottom: 60px;text-align: right}
  .expand-desc{font-size: 16px;color: #333333;line-height: 34px;text-align: justify}
  .expand video{width: 700px;margin: 10px 0px;}
  .expand .visualDevelopment-img2{width: 720px;}

  /*安全可靠*/
  .security{height: 100vh;width:100vw;background: url("../assets/img/keyFeatures/security-bg.png") no-repeat;background-size: 100% 100%;padding-top: 150px;text-align: center;}
  .security-div{width: 1050px;display: flex;justify-content: center;margin:auto}
  .security-left{margin-right: 20px}
  .security-right{position: relative;left: 20px;top: 50px}
  .security-title{font-size: 38px;color: #2E2E2E;line-height: 52px;font-weight: bold;margin-bottom: 60px;text-align: left}
  .security-desc{font-size: 16px;color: #333333;line-height: 34px;text-align: justify}
  .security-right img{width: 700px}

  /*单服务*/
  .singleService{height: 100vh;width:100vw;background: url("../assets/img/keyFeatures/singleService-bg.png") no-repeat;background-size: 100% 100%;padding-top: 200px;text-align: center;}
  .singleService-div{width: 1050px;display: flex;justify-content: center;margin:auto}
  .singleService-right{margin-left: 100px}
  .singleService-left{position: relative;right: 20px;top: -150px}
  .singleService-title{font-size: 38px;color: #2E2E2E;line-height: 52px;font-weight: bold;margin-bottom: 60px;text-align: right}
  .singleService-desc{font-size: 16px;color: #333333;line-height: 34px;text-align: justify}
  .singleService img{width: 600px}
}
</style>



// WEBPACK FOOTER //
// src/components/KeyFeatures.vue